export default `
  subscription OnDeleteWorkflow($projectId: String!) {
    onDeleteWorkflow (projectId: $projectId) {
      deleteWorkflow {
        id
      }
      projectId
    }
  }
`
